export default __webpack_public_path__ + "static/media/MT_Logo_mobile.svg";